module.exports = __webpack_public_path__ + "932b85d34c7bb0c49f6969612cb5fe98.svg";